/**
 * This is a file containing constants for navigators loceted directly in the rootStack in AuthScreen
 * The ResponsiveStackNavigatur displays stack differently basing on these constants
 * */
export default {
    CENTRAL_PANE_NAVIGATOR: 'CentralPaneNavigator',
    RIGHT_MODAL_NAVIGATOR: 'RightModalNavigator',
    FULL_SCREEN_NAVIGATOR: 'FullScreenNavigator',
};
